<template>
  <div class="space-between-y">
    <input-item label="方案名称">
      <el-input v-model="form.name" placeholder="请输入方案名称"></el-input>
    </input-item>
    <input-item label="VIP类型">
      <el-select v-model="form.vipType" placeholder="请选择">
        <el-option label="教师VIP" value="teacher"></el-option>
        <el-option label="家长VIP" value="parent"></el-option>
      </el-select>
    </input-item>
    <input-item label="是否促销">
      <el-switch v-model="form.isPromotion" active-text="是" inactive-text="否"></el-switch>
    </input-item>
    <input-item label="方案时长（天）">
      <el-input v-model="form.duration" placeholder="请输入时长"></el-input>
    </input-item>
    <input-item label="方案价格（元）">
      <el-input v-model="form.price" placeholder="请输入价格"></el-input>
    </input-item>

    <el-button type="primary" @click="save">保存方案</el-button>

  </div>
</template>

<script>
import {vip} from "@/api/miu/vip";
import InputItem from "@/components/base/layout/InputItem.vue";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'MiuVipPlanSave',
  components: {InputItem},
  data() {
    return {
      form: {
        vipType: null,
        duration: null,
        price: null,
        isPromotion: false,
        name: null,
      },

    }
  },
  props: {
    id: Number
  },

  created() {
    if (this.id) {
      this.getData();
    }
  },

  methods: {
    getData() {
      vip.plan.get(this.id).then(res => {
        this.form = res.data;
      })
    },

    save() {
      this.$confirm("确定保存吗？").then(() => {
        vip.plan.save(this.id, this.form.name, this.form.vipType, this.form.duration, this.form.price, this.form.isPromotion).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.$emit("saved");
          }
        })
      })
    },
  }
}
</script>

<style scoped>

</style>